import http_request from './http_request'
import http_agent from './http_agent'
import superagentPromisePlugin from 'superagent-promise-plugin'
import config from 'config'

function submitPoll(device_uid, slide, headers, answers) {
	return http_request.post(config.hub + 'datasync/poll')
		.withHeaders(headers)
		.send({
			answers,
			device_uid,
			slide,
			subslide: '0',
		})
}

function submitQuiz(device_uid, slide, subslide, headers, answers, quizLength) {
	const serviceName = quizLength === 1 ? 'qa' : 'quiz'
	return http_request.post(`${config.hub}datasync/${serviceName}`)
		.withHeaders(headers)
		.send({
			answers,
			device_uid,
			slide,
			subslide: quizLength === 1 ? '0' : subslide,
		})
}

function submitOeq(device_uid, slide, headers, answers, audio_uid) {
	return http_request.post(config.hub + 'datasync/poll')
		.withHeaders(headers)
		.send({
			answers,
			device_uid,
			slide,
			subslide: '0',
			audio_uid,
		})
}

function submitDrawIt(device_uid, slide, subslide, session_uid, headers, dataURL) {

	const formData = new FormData()

	// @TODO: check if it is image instead of file
	// formData.append('image', file, device_uid)

	const blobBin = atob(dataURL.split(',')[1])
	const array = []
	for (let i = 0; i < blobBin.length; i++) {
		array.push(blobBin.charCodeAt(i))
	}
	const file = new Blob([new Uint8Array(array)], {type: 'image/png'})

	formData.append('image', file, device_uid)
	formData.append('Filename', device_uid)

	formData.append('device_uid', device_uid)
	formData.append('slide', slide)
	formData.append('subslide', subslide)
	formData.append('session_uid', session_uid)
	formData.append('decodeImage', 'false')

	return http_request.post(config.hub + 'datasync/drawit')
		.type(null)
		.withHeaders(headers)
		.send(formData)
}

function submitDrawItPreview(device_uid, slide, headers, blobActions, hash) {

	const formData = new FormData()

	formData.append('strokes', blobActions, 'strokes')
	formData.append('device_uid', device_uid)
	formData.append('slide', slide)
	formData.append('hash', hash)

	return http_request.post(`${config.api_hub}student/drawit/preview`)
		.type(null)
		.withHeaders(headers)
		.send(formData)

}

function getStatus(device_uid, slide, subslide, aliveTime, headers) {
	return http_request.post(config.hub + 'session/status')
		.withHeaders(headers)
		.send({
			aliveTime,
			device_uid,
			slide,
			subslide,
		})
}

function getTimer(device_uid, slide, headers) {
	return http_request.get(`${config.api_hub}student/slide/${slide}/timer/status`)
		.withHeaders(headers)
		.send({
			device_uid,
			slide,
		})
}

function loadZipFile(device_uid, slide, headers) {
	return http_agent.get(`${config.api_hub}teacher/drawit/preview`)
		.use(superagentPromisePlugin)
		.set(headers)
		.responseType('blob')
		.query({
			device_uid,
			slide,
		})
		.then(response => response.xhr.response)
}

function getStudentDrawit(slide, headers) {
	return http_request.get(`${config.api_hub}student/drawit`)
		.withHeaders(headers)
		.send({
			slide,
		})
}


function submitLeadData(device_uid, name, optionalName, headers, ltiLisResult) {

	const formData = new FormData()
	formData.append('device_uid', device_uid)
	formData.append('nickname', name)
	formData.append('student_id', optionalName)
	if (ltiLisResult) {
		formData.append('ltiLisResult', ltiLisResult)
	}

	return http_request.post(`${config.hub}datasync/lead`)
		.type(null)
		.withHeaders(headers)
		.send(formData)
}

export default {
	submitPoll,
	submitQuiz,
	getStatus,
	submitOeq,
	getTimer,
	submitDrawIt,
	submitDrawItPreview,
	loadZipFile,
	getStudentDrawit,
	submitLeadData,
}
